import { GetterTree, MutationTree, ActionTree, ActionContext, Module } from 'vuex';
import { RootState } from '../types';

function createState(): ImageIdState {
  const state: ImageIdState = {} as ImageIdState;
  clearState(state);
  return state;
}

function clearState(state: ImageIdState): void {
  state.idDocumentFront = '';
  state.idDocumentBack = '';
  state.idDocumentDiagonal = '';
  state.faceFront = '';
  state.faceMotion = '';
}

export const getters: GetterTree<ImageIdState, RootState> = {};

export const mutations: MutationTree<ImageIdState> = {
  storeIdDocumentFront(state, payload: string) {
    state.idDocumentFront = payload;
  },

  storeIdDocumentBack(state, payload: string) {
    state.idDocumentBack = payload;
  },

  storeIdDocumentDiagonal(state, payload: string) {
    state.idDocumentDiagonal = payload;
  },

  storeFaceFront(state, payload: string) {
    state.faceFront = payload;
  },

  storeFaceMotion(state, payload: string) {
    state.faceMotion = payload;
  },

  clearState(state: ImageIdState) {
    clearState(state);
  }
};

export const actions: ActionTree<ImageIdState, RootState> = {
  clearState(context: ActionContext<ImageIdState, RootState>): void {
    context.commit('clearState');
  }
};

export const imageID: Module<ImageIdState, RootState> = {
  namespaced: true,
  state: createState,
  getters,
  mutations,
  actions
};

export type ImageIdState = {
  idDocumentFront: string;
  idDocumentBack: string;
  idDocumentDiagonal: string;
  faceFront: string;
  faceMotion: string;
};
